import App from '../../../_core/ts/app/app';
import AppOptions from '../../../_core/ts/app/options';

document.addEventListener('DOMContentLoaded', () => {
    const app = new App((<any>window).config as AppOptions);
    (<any>window).app = app;

    app.run();
});

